__turbopack_context__.v({
  "currentDropDown": "index-module__57dyCG__currentDropDown",
  "dropDownContent": "index-module__57dyCG__dropDownContent",
  "dropDownItem": "index-module__57dyCG__dropDownItem",
  "languageDropdown": "index-module__57dyCG__languageDropdown",
});
